import { EntityProfileHeaderInfoItemDeadlineEditState } from './useEntityProfileHeaderInfoItemDeadlineEdit.constants'

export function isDeadlineEditStateSaving(editState) {
  return editState === EntityProfileHeaderInfoItemDeadlineEditState.Saving
}

export function isDeadlineEditStateView(editState) {
  return editState === EntityProfileHeaderInfoItemDeadlineEditState.View
}
